<div class="dx-card" id="accordion">
  <dx-accordion
    #accordion
    [dataSource]="[{ title: 'Case Type', item: {} }]"
    [collapsible]="true"
    [animationDuration]="300"
    [focusStateEnabled]="false"
    [hoverStateEnabled]="false"
    [selectedIndex]="-1"
    [deferRendering]="false"
    (onSelectionChanged)="onAccordionClick($event)"
  >
    <div *dxTemplate="let itemData of 'title'">
      <h3>
        <span style="padding-left: 0.3em">Case Type</span>
      </h3>
    </div>
    <div *dxTemplate="let itemData of 'item'">
      <dx-form #caseTypeForm labelMode="floating" class="caseType-form">
        <dxi-item
          itemType="group"
          [colCount]="12"
          [colCountByScreen]="{ xs: 1 }"
        >
          <!-- Line 1 -->
          <dxi-item name="caseType" [colSpan]="12">
            <div *dxTemplate="let data">
              <dx-radio-group
                style="padding: 0 11px; margin-bottom: -10px"
                [dataSource]="caseTypeDataSource"
                [value]="selectedCaseType?.keyValue"
                displayExpr="displayValue"
                valueExpr="keyValue"
                layout="horizontal"
                (onValueChanged)="onCaseTypeChanged($event)"
              >
              </dx-radio-group>
            </div>
          </dxi-item>

          <!-- Static Case Type Fields with Real Data -->
          <!-- Board Material and Case Material - only for 1-Piece and 3-Piece -->
          <ng-container
            *ngIf="
              selectedCaseType?.keyValue &&
              selectedCaseType?.keyValue?.toUpperCase() !== 'CASE_WRAP'
            "
          >
            <!-- Board Material -->
            <dxi-item name="boardMaterial" [colSpan]="12">
              <div *dxTemplate="let data">

                <app-option-mapping-select-box
                  #boardMaterialSelectBox
                  [publisherId]="selectedPublisherId"
                  [classification]="selectedClassification"
                  subcategory="CASE_TYPE"
                  inputName="BOARD_MATERIAL"
                  dependsOnField="TYPE"
                  [dependsOnValue]="selectedCaseType?.keyValue"
                  [summaryField]="{
                    name: 'boardMaterial',
                    category: 'Case Type Specification',
                    label: 'Board Material'
                  }"
                  (onValueChanged)="boardMaterialChanged($event)"
                  (summaryUpdate)="setBoardMaterialSummaryItems($event)"
                ></app-option-mapping-select-box>
              </div>
            </dxi-item>

            <!-- Case Material Triple -->
            <dxi-item name="caseMaterialTriple" [colSpan]="12">
              <div *dxTemplate="let data">

                <app-option-mapping-select-box
                  #caseMaterialSelectBox
                  [publisherId]="selectedPublisherId"
                  [classification]="selectedClassification"
                  label="Case Material"
                  subcategory="CASE_TYPE"
                  inputName="CASE_MATERIAL"
                  dependsOnField="TYPE"
                  [dependsOnValue]="selectedCaseType?.keyValue"
                  (onValueChanged)="caseMaterialChanged($event)"
                  (onFieldItemsChanged)="caseMaterialFieldItemsChanged($event)"
                ></app-option-mapping-select-box>
              </div>
            </dxi-item>


            <dxi-item name="caseMaterial" [colSpan]="4">
              <div *dxTemplate="let data">
                <dx-text-box
                  [readOnly]="true"
                  [value]="selectedCaseMaterialDisplayValue"
                  class="readonly-text"
                  label="Material"
                  stylingMode="none"
                ></dx-text-box>
              </div>
            </dxi-item>

            <dxi-item name="caseColor" [colSpan]="4">
              <div *dxTemplate="let data">
                <dx-text-box
                  [readOnly]="true"
                  [value]="selectedCaseColorDisplayValue"
                  class="readonly-text"
                  label="Color"
                  stylingMode="filled"
                ></dx-text-box>
              </div>
            </dxi-item>

            <dxi-item name="embossing" [colSpan]="4">
              <div *dxTemplate="let data">
                <dx-text-box
                  [readOnly]="true"
                  [value]="selectedCaseFinishingDisplayValue"
                  class="readonly-text"
                  label="Finishing"
                  stylingMode="filled"
                ></dx-text-box>
              </div>
            </dxi-item>

          </ng-container>

          <!-- Standard fields for 1-Piece and 3-Piece Case Types -->
          <ng-container
            *ngIf="
              selectedCaseType?.keyValue &&
              selectedCaseType?.keyValue?.toUpperCase() !== 'CASE_WRAP'
            "
          >
            <!-- Spine Stamping -->
            <dxi-item
              name="spineStamping"
              [colSpan]="6"
            >
              <div *dxTemplate="let data">
                <app-spine-stamping-select
                  [optionId]="spineStampingOptionId"
                  (onValueChanged)="spineStampingChanged($event)"
                  ></app-spine-stamping-select>
              </div>
            </dxi-item>

            <!-- Foil -->
            <dxi-item
              name="foil"
              [colSpan]="6"
            >
              <div *dxTemplate="let data">
                <dx-select-box
                  [disabled]="spineStampingValue === undefined"
                  stylingMode="filled"
                  [dataSource]="foilFieldItems"
                  label="Foil"
                  displayExpr="displayValue"
                  valueExpr="keyValue"
                  [searchEnabled]="false"
                  style="caret-color: transparent"
                  [value]="selectedFoil?.keyValue"
                  (onValueChanged)="foilChanged($event)"
                ></dx-select-box>
              </div>
            </dxi-item>

            <!-- Front and Back Panel Stamping -->
            <dxi-item
              name="frontBackStamping"
              [colSpan]="
                selectedFrontBackStamping?.keyValue &&
                selectedFrontBackStamping?.keyValue?.toUpperCase() !== 'NONE'
                  ? 6
                  : 12
              "
            >
              <div *dxTemplate="let data">
                <dx-select-box
                  stylingMode="filled"
                  [dataSource]="frontBackStampingFieldItems"
                  label="Front & Back Panel Stamping"
                  displayExpr="displayValue"
                  valueExpr="keyValue"
                  [searchEnabled]="false"
                  style="caret-color: transparent"
                  [value]="selectedFrontBackStamping?.keyValue"
                  (onValueChanged)="frontBackStampingChanged($event)"
                ></dx-select-box>
              </div>
            </dxi-item>

            <!-- Foil -->
            <dxi-item
              name="frontBackFoil"
              *ngIf="
                selectedFrontBackStamping?.keyValue &&
                selectedFrontBackStamping?.keyValue?.toUpperCase() !== 'NONE'
              "
              [colSpan]="5"
            >
              <div *dxTemplate="let data">
                <dx-select-box
                  stylingMode="filled"
                  [dataSource]="frontBackFoilFieldItems"
                  label="Foil"
                  displayExpr="displayValue"
                  valueExpr="keyValue"
                  [searchEnabled]="false"
                  style="caret-color: transparent"
                  [value]="selectedFrontBackPanelFoil?.keyValue"
                  (onValueChanged)="(null)"
                ></dx-select-box>
              </div>
            </dxi-item>
          </ng-container>

          <!-- Case Wrap specific fields -->
          <ng-container
            *ngIf="
              selectedCaseType?.keyValue &&
              selectedCaseType?.keyValue?.toUpperCase() === 'CASE_WRAP'
            "
          >
            <dxi-item [colSpan]="12">
              Under construction - Case Wrap options coming soon!
            </dxi-item>
          </ng-container>
        </dxi-item>
      </dx-form>
    </div>
  </dx-accordion>
</div>
